import React, { useState } from 'react';
import { Plus, Loader2 } from 'lucide-react';

export default function CategoryForm({ onSuccess }) {
  const [name, setName] = useState('');
  const [icon, setIcon] = useState('folder');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const iconOptions = [
    { id: 'folder', label: 'Thư mục' },
    { id: 'shirt', label: 'Áo quần / Thời trang' },
    { id: 'sparkles', label: 'Làm đẹp / Mỹ phẩm' },
    { id: 'laptop', label: 'Điện tử / Công nghệ' },
    { id: 'home', label: 'Gia dụng / Nhà cửa' },
    { id: 'coffee', label: 'Ẩm thực / Đồ ăn' },
    { id: 'heart', label: 'Sức khỏe / Y tế' },
    { id: 'watch', label: 'Phụ kiện / Đồng hồ' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;

    setIsSubmitting(true);
    setStatusMessage(null);

    // Generate slug from Vietnamese name
    const slug = name
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    try {
      const res = await fetch('/api/categories', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name.trim(),
          slug: slug || 'cat-' + Date.now(),
          icon,
          display_order: 10
        })
      });

      const data = await res.json();
      if (data.success) {
        setStatusMessage({ type: 'success', text: `Đã tạo danh mục "${name}" thành công!` });
        setName('');
        if (onSuccess) onSuccess();
      } else {
        setStatusMessage({ type: 'error', text: data.error || 'Lỗi khi tạo danh mục.' });
      }
    } catch {
      setStatusMessage({ type: 'error', text: 'Không thể kết nối đến máy chủ.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {statusMessage && (
        <div
          className={`p-3 rounded-xl text-xs flex items-center justify-between ${
            statusMessage.type === 'success'
              ? 'bg-emerald-950/80 text-emerald-200 border border-emerald-700/60'
              : 'bg-rose-950/80 text-rose-200 border border-rose-700/60'
          }`}
        >
          <span>{statusMessage.text}</span>
          <button
            type="button"
            onClick={() => setStatusMessage(null)}
            className="text-xs font-bold px-1"
          >
            ×
          </button>
        </div>
      )}

      <div>
        <label className="block text-xs font-bold text-amber-200 mb-1">
          Tên danh mục mới *
        </label>
        <input
          type="text"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="VD: Đồ chơi trẻ em, Dụng cụ thể thao..."
          className="w-full bg-[#2B0509] border border-[#520B12] rounded-xl px-3 py-2 text-xs text-[#FFF5E6] placeholder-amber-200/40 focus:outline-none focus:border-[#F5A623] focus:ring-2 focus:ring-[#F5A623]/20 transition"
        />
      </div>

      <div>
        <label className="block text-xs font-bold text-amber-200 mb-1">
          Biểu tượng danh mục
        </label>
        <select
          value={icon}
          onChange={(e) => setIcon(e.target.value)}
          className="w-full bg-[#2B0509] border border-[#520B12] rounded-xl px-3 py-2 text-xs text-[#FFF5E6] focus:outline-none focus:border-[#F5A623] focus:ring-2 focus:ring-[#F5A623]/20 transition"
        >
          {iconOptions.map(opt => (
            <option key={opt.id} value={opt.id}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <button
        type="submit"
        disabled={isSubmitting || !name.trim()}
        className="w-full py-2.5 bg-gradient-to-r from-[#F5A623] to-[#E58F10] hover:brightness-110 disabled:opacity-50 text-[#240306] rounded-xl text-xs font-black flex items-center justify-center gap-2 transition shadow-md"
      >
        {isSubmitting ? (
          <>
            <Loader2 size={14} className="animate-spin" />
            <span>Đang tạo danh mục...</span>
          </>
        ) : (
          <>
            <Plus size={15} />
            <span>Tạo danh mục mới</span>
          </>
        )}
      </button>
    </form>
  );
}
